module.exports = __webpack_public_path__ + "static/img/advantageMap.0c6c5548.png";